<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
